module.exports = __webpack_public_path__ + "images/help/icn-fag-use-5a6ee85950a4488a269f62c9541de66a.png";